export const getNumberValueFromString = (value: string) =>
  // strip everything except numbers from the input value
  value.replace(/[^0-9.]/g, '');
